export const KSMART_BASE_URL = "https://ksmart.lsgkerala.gov.in";
